/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx, useTheme } from '@emotion/react';
import React, { ReactNode } from 'react';
import { dayEventsLayerCss, getDayTimeGridOverlayStyle, TimeGridAxis } from '../styles';

interface IDayTimeGridSurfaceProps {
	hourSize: number;
	gridLineStepMinutes: number | undefined;
	axis: TimeGridAxis;
	slotButtons?: ReactNode;
	children: ReactNode;
}

export const DayTimeGridSurface: React.FC<IDayTimeGridSurfaceProps> = ({
	hourSize,
	gridLineStepMinutes,
	axis,
	slotButtons,
	children,
}) => {
	const colors = useTheme();
	return (
		<>
			{!!gridLineStepMinutes && (
				<div css={getDayTimeGridOverlayStyle(colors, hourSize, gridLineStepMinutes, axis)} />
			)}
			{slotButtons}
			<div css={dayEventsLayerCss}>{children}</div>
		</>
	);
};
